<script>
import {defineComponent} from 'vue';
import {notification} from "@/helpers/notifications";
import {has, values} from "lodash";
import formatGraphQLErrors from "@/errors/formatGraphQLErrors";
import {useVuelidate} from "@vuelidate/core";
import {integer, helpers, required} from "@vuelidate/validators";
import {UPDATE_GROUP} from "@/graphql/mutations/group/update";

export default defineComponent({
  name: "ModifyNumberEvents",
  props: {
    modal: {
      type: Boolean,
      required: true,
    },
    group: {
      type: Object,
      required: true
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      form: {
        numberEvents: {
          required: helpers.withMessage("La cantidad de eventos es requerido", required),
          integer: helpers.withMessage("El valor requerido debe ser un número", integer),
        },
      },
    }
  },
  mounted() {
    setTimeout(() => {
      this.modalShow = this.modal;
    }, 800)
  },
  data: () => ({
    error: null,
    modalShow: false,
    submitted: false,
    form: {
      numberEvents: null,
    },
  }),
  methods: {
    async updateNumberEvents() {
      try {
        this.submitted = true;
        this.v$.$touch();

        if (this.v$.$invalid) {
          return false;
        }

        const {data} = await this.$apollo.mutate({
          mutation: UPDATE_GROUP,
          fetchPolicy: "network-only",
          variables: {
            id: this.group.id,
            input: this.form
          }
        });

        const infoGroup = data.updateGroup;
        this.$emit('groupUpdated', infoGroup);

        this.closedModal();
        notification('success', `El grupo ${infoGroup.name} se ha modificado el número de eventos.`);
        this.resetForm();

        return infoGroup;
      } catch (errors) {
        let dataError = has(errors, 'graphQLErrors') ? formatGraphQLErrors(errors.graphQLErrors) : errors.message

        if (has(dataError, 'category') && dataError.category === 'validation') {
          dataError = values(dataError.errors);
        }

        if (has(dataError, 'category') && dataError.category === 'user') {
          dataError = dataError.message
        }

        if (has(dataError, 'category') && dataError.category === 'graphql') {
          dataError = dataError.message
        }

        this.error = dataError;

        notification('error', dataError);
      }
    },
    closedModal() {
      this.modalShow = false;
    },
    resetForm() {
      this.form.numberEvents = null;
    },
  },
  watch: {
    modal: function (value) {
      this.modalShow = value;
    },
    modalShow: function (newValue) {
      this.$emit('modalClosedModifyNumberEvents', newValue);
    },
    'form.numberEvents': function (value) {
      if (value) {
        this.form.numberEvents = Number(value);
      }
    }
  }
});
</script>

<template>
  <b-modal
      v-model="modalShow"
      hide-footer
      hide-header
      hide-header-close
      content-class="border-0"
      class="v-modal-custom"
      centered
  >
    <form
        autocomplete="off"
        id="grouplist-form"
        class="needs-validation"
        @submit.prevent="updateNumberEvents"
    >
      <b-row>
        <b-col lg="12">
          <div class="px-1 pt-1">
            <div class="modal-team-cover position-relative mb-0 mt-n4 mx-n4 rounded-top overflow-hidden">

              <img src="@/assets/images/placeholders/cover.png" alt="" id="cover-img" class="img-fluid"/>

              <div class="d-flex position-absolute start-0 end-0 top-0 p-3">
                <div class="flex-grow-1">
                  <h5 class="modal-title text-white" id="createGroupLabel">Modificar número de eventos</h5>
                </div>

                <div class="flex-shrink-0">
                  <div class="d-flex gap-3 align-items-center">
                    <button
                        type="button"
                        class="btn-close btn-close-white"
                        id="createMemberBtn-close"
                        @click="modalShow = !modalShow">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-center mb-4 mt-n5 pt-2">
            <div class="position-relative d-inline-block">
              <div class="avatar-lg">
                <div
                    id="cover-img"
                    class="avatar-lg img-thumbnail rounded-circle mx-auto profile-img flex-shrink-0 cursor-pointer bg-gray-custom"
                >
                  <div
                      class="avatar-title rounded-circle text-uppercase fs-24 position-relative bg-gray-custom text-gray-custom"
                  >
                    ?
                    <span class="position-absolute bottom-0 start-100 translate-middle badge rounded-pill bg-white w-50 h-50">
                    <i class="ri-pencil-line text-red-custom fs-20 d-flex justify-content-around"></i>
                  </span>
                  </div>

                </div>

              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="numberEvents" class="form-label">Número de eventos</label>
            <input
                type="text"
                class="form-control"
                id="numberEvents"
                placeholder="Cantidad de eventos"
                v-model="form.numberEvents"
                :class="{
                  'is-invalid': submitted && v$.form.numberEvents.$error,
                }"
            >

            <div v-for="(item, index) in v$.form.numberEvents.$errors" :key="index" class="invalid-feedback">
              <span v-if="item.$message">{{ item.$message }}</span>
            </div>

          </div>

          <div class="invalid-feedback" v-if="error">
            <span>{{ error }}</span>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button type="button" variant="light" @click="modalShow = false">Cerrar</b-button>

            <b-button
                type="submit"
                variant="danger"
            >
              Modificar
            </b-button>
          </div>
        </b-col>
      </b-row>
    </form>

  </b-modal>
</template>

